import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { resultItem } from '../utils/propTypes'

import BudgetRating from './BudgetRating'
import Carousel from './Carousel'

import { accommodationTypeMap } from '../utils/constants'

export default class SearchResults extends Component {
  static propTypes = {
    eventCity: PropTypes.string.isRequired,
    results: PropTypes.arrayOf(resultItem).isRequired,
    setActiveProperty: PropTypes.func.isRequired,
    toggleWishlist: PropTypes.func.isRequired,
    //  something strange here
    isManageBookingSearchResult: PropTypes.func.optional
  }


  setActivePropertyFactory = (property) => () => this.props.setActiveProperty(property)

  toggleWishlistFactory = (property) => () => this.props.toggleWishlist(property)

  navigateToItemFactory = (item) => () => {
    location.href = item.url + '&comesFromListing=true';

  }
  getMediumSizedImageUrl = (originalImageUrl) => {
      var urlparts = originalImageUrl.split('/')
      var positionToInsert = urlparts.length -1;
      const items = urlparts;
      const insert = (arr, index, newItem) => [
        // part of the array before the specified index
        ...arr.slice(0, index),
        // inserted item
        newItem,
        // part of the array after the specified index
        ...arr.slice(index)
      ]
    return insert(items, positionToInsert, 'big').join('/')
  }

  openDownloadKeyInstructionsLink = (referenceNumber) => {
    let downloadUrl = '/account/booking/instructions/' + this.props.bookingIdsForBookedAccommodations[referenceNumber] + '/' + this.props.wishlistOrderAccIdsForBookedAccommodations[referenceNumber] +'/';
    window.open(downloadUrl)
  };


  render () {
    console.log('props for rendering search results are: ', this.props)
    const { eventCity, results } = this.props

    if(this.props.isManageBookingSearchResult == null){
      return (
      <div className='card-wrapper'>
        {results.map((item) => (
          <div
            className={`accommodation-card accommodation-card--${item.wishlisted ? 'highlight' : 'default'}`}
            key={item.uuid}
            onMouseEnter={this.setActivePropertyFactory(item.uuid)}
            onMouseLeave={this.setActivePropertyFactory(null)}
          >
            <div className='accommodation-card__gallery'>
              <Carousel onClick={this.navigateToItemFactory(item)}>
                {item.images.map((image, index) => (
                  <img alt={`${item.title} Image #${index + 1}`} key={image} src={this.getMediumSizedImageUrl(image)} />
                ))}
              </Carousel>
            </div>

            <div className='accommodation-card__details'>
              <button
                className='accommodation-card__floating-button'
                type='button'
                onClick={this.toggleWishlistFactory(item.uuid)}
              >
                <span className='sr-only'>Wishlist this item</span>
              </button>

              <h3 className='accommodation-card__title'>
                <a href={item.url+ '&comesFromListing=true'}>{item.title}</a>
              </h3>
              <h4 className='accommodation-card__subtitle'>
                {accommodationTypeMap[item.type]}, {eventCity} #{item.reference_number}
              </h4>

              <ul className='accommodation-card__features list-inline'>
                <li className='bedrooms'>{item.bedrooms}</li>
                <li className='beds'>{item.beds}</li>
                <li className='distance'>{item.distance}km</li>
                <li className='price'><BudgetRating rating={item.budget} /></li>
              </ul>
            </div>
          </div>
        ))}
      </div>
    )
    }
    else{
      // manage booking search results we render the search results a little bit differently
        return (
      <div className='card-wrapper'>
        {results.map((item) => (
          <div
            className={`accommodation-card accommodation-card--${item.wishlisted ? 'highlight' : 'default'}`}
            key={item.uuid}
            onMouseEnter={this.setActivePropertyFactory(item.uuid)}
            onMouseLeave={this.setActivePropertyFactory(null)}
          >
            <div className='accommodation-card__gallery'>
              <Carousel onClick={this.navigateToItemFactory(item)}>
                {item.images.map((image, index) => (
                  <img alt={`${item.title} Image #${index + 1}`} key={image} src={this.getMediumSizedImageUrl(image)} />
                ))}
              </Carousel>
            </div>

            <div className='accommodation-card__details'>

              <h3 className='accommodation-card__title'>
                <a href={item.url}>{item.title}</a>
              </h3>
              <h4 className='accommodation-card__subtitle'>
                {accommodationTypeMap[item.type]}, {eventCity} #{item.reference_number}
              </h4>

              <ul className='accommodation-card__features list-inline'>
                <li className='bedrooms'>{item.bedrooms}</li>
                <li className='beds'>{item.beds}</li>
                <li className='distance'>{item.distance}km</li>
                <li className='price'>{this.props.pricesForBookedAccommodations[item.reference_number]}€</li>
              </ul>
            </div>
            <div className="accommodation-card__footer">
  <a onClick={()=> this.openDownloadKeyInstructionsLink(item.reference_number)}> <label style={{background: '#808184', color: '#fff', display: 'block', padding: '1rem', textAlign: 'right', transition: 'background .2s ease', cursor: 'pointer', position: 'relative'}} >Download Key Instructions</label></a>
</div>
          </div>
        ))}
      </div>
    )

    }

  }
}



// WEBPACK FOOTER //
// ./src/components/SearchResults.js